/**
 * Decrements the current value by 1.
 *
 * @param {number|string} x - Current value.
 * @returns {number}
 */
export function dec(x) {
  return Number(x) - 1;
}
